var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgFormFieldProperties = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1680_205342)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.5626 30C36.5605 31.2428 36.2496 32.4657 35.6578 33.5586C35.0661 34.6516 34.212 35.5803 33.1723 36.2613L30.7383 44.8277C38.2243 43.9863 44.0626 37.7086 44.0626 30C44.0626 26.0218 42.4822 22.2064 39.6692 19.3934C36.8561 16.5804 33.0408 15 29.0626 15C21.354 15 15.0762 20.8383 14.2348 28.3242L22.8024 25.8891C23.6854 24.537 24.9817 23.5065 26.4981 22.9513C28.0145 22.3961 29.6697 22.3459 31.217 22.8081C32.7643 23.2704 34.1207 24.2204 35.084 25.5164C36.0474 26.8125 36.566 28.3852 36.5626 30V30ZM29.0626 0.9375C13.0172 0.9375 0.0129395 13.9453 0.0129395 30C0.0129395 30.9832 0.064502 31.9535 0.160596 32.9121C0.771021 32.3719 1.49037 31.969 2.26997 31.7309L7.52466 30.2344C7.52466 30.1547 7.51294 30.0785 7.51294 30C7.51294 25.7353 8.77756 21.5665 11.1469 18.0205C13.5162 14.4746 16.8838 11.7109 20.8238 10.0788C24.7639 8.44683 29.0994 8.01982 33.2821 8.85182C37.4648 9.68381 41.3069 11.7374 44.3224 14.753C47.338 17.7686 49.3916 21.6106 50.2236 25.7934C51.0556 29.9761 50.6286 34.3116 48.9966 38.2516C47.3646 42.1916 44.6009 45.5592 41.0549 47.9286C37.509 50.2979 33.3401 51.5625 29.0754 51.5625C28.9958 51.5625 28.9184 51.552 28.8411 51.5508L27.3469 56.809C27.1117 57.5878 26.7121 58.3072 26.1751 58.9184C27.1313 59.0133 28.1016 59.0648 29.0836 59.0648C45.1172 59.0625 58.1251 46.0547 58.1251 30C58.1251 13.9453 45.1172 0.9375 29.0626 0.9375Z",
    fill: "url(#paint0_linear_1680_205342)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3839 28.2011C28.7279 28.1032 29.0918 28.0991 29.438 28.1891C29.7841 28.279 30.1 28.4599 30.3528 28.7128C30.6056 28.9658 30.7863 29.2817 30.8761 29.6279C30.9659 29.9741 30.9616 30.338 30.8636 30.6819L23.7316 55.7811C23.2265 57.5589 20.7925 57.7733 19.9921 56.1011L16.139 48.0772L5.69173 58.5245C5.52292 58.6935 5.32244 58.8277 5.10175 58.9192C4.88106 59.0107 4.6445 59.0578 4.4056 59.0578C4.16669 59.0578 3.93013 59.0107 3.70945 58.9192C3.48876 58.8277 3.28828 58.6935 3.11947 58.5245H3.11361L0.535481 55.9464C0.365306 55.7778 0.230117 55.5772 0.137679 55.3562C0.045241 55.1352 -0.00262468 54.8981 -0.00316913 54.6585C-0.00371358 54.419 0.043074 54.1817 0.134506 53.9602C0.225939 53.7388 0.360214 53.5376 0.529622 53.3682H0.535481L10.9827 42.921L2.97181 39.0761C1.30189 38.2768 1.514 35.8405 3.2929 35.3354L28.3863 28.2011H28.3839Z",
    fill: "url(#paint1_linear_1680_205342)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1680_205342",
    x1: 29.069,
    y1: 0.9375,
    x2: 29.069,
    y2: 59.0648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1680_205342",
    x1: 15.4686,
    y1: 28.1245,
    x2: 15.4686,
    y2: 59.0578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1680_205342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.125,
    height: 60,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgFormFieldProperties);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/form-field-properties.7707f7cb911d6db166e39ca42587c33c.svg";